import React, { Fragment } from "react";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import StatusField from "components/StatusField";
import {
  Datagrid,
  Filter,
  TextField,
  SearchInput,
  FunctionField,
  BulkDeleteButton,
  SelectInput,
  BulkDeleteButtonProps,
  ListProps,
} from "react-admin";
import { statusList } from "./conts";
import { GridinRow, GridLabel } from "utils/style";
import CustomDateField from "components/CustomDateField";
import { availableOnlySuperAdminAndAdminAndFinance } from "utils/tools";
import ListWrapper from "../../components/ListWrapper";
import ListShowButton from "../../components/ListShowButton";
import ListEditButton from "../../components/ListEditButton";
import ActionsMenu from "../../components/ActionsMenu";

const BulkActionButtons = (props: BulkDeleteButtonProps) => (
  <Fragment>
    <BulkDeleteButton {...props} />
  </Fragment>
);

const PersonInChargeFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <SelectInput label="Status" source="Status" choices={statusList} alwaysOn />
  </Filter>
);

const PersonInChargeList = (props: ListProps) => {
  const breadcrumb = [{ link: "/personInCharges", title: "Person In Charges" }];

  return (
    <>
      <ListWrapper
        breadcrumb={breadcrumb}
        headerTitle="Person In Charges"
        isNotHaveSchoolFilter
        exporter={false}
        filters={<PersonInChargeFilter />}
        sort={{ field: "CreatedAt", order: "DESC" }}
        bulkActionButtons={<BulkActionButtons />}
        {...props}
        hasCreate={false}
      >
        <Datagrid>
          <FunctionField
            label="Person In Charge Info"
            render={() => (
              <SanitizedGrid container spacing={2}>
                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Id :
                  </Typography>
                  <TextField source="id" />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Name :
                  </Typography>
                  <FunctionField
                    render={(record: any) =>
                      `${record.firstName} ${record.lastName}`
                    }
                  />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Email :
                  </Typography>
                  <TextField source="user.email" emptyText="-" />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Mobile :
                  </Typography>
                  <TextField source="mobile" />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Mbc Code :
                  </Typography>
                  <TextField source="user.mbcCustomerId" />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Billing Name :
                  </Typography>
                  <TextField source="billingAddress.name" />
                </Grid>
              </SanitizedGrid>
            )}
          />
          <FunctionField
            label="Company Info"
            render={() => (
              <SanitizedGrid container spacing={2}>
                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Id :
                  </Typography>
                  <TextField source="company.id" />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Name :
                  </Typography>
                  <TextField source="company.name" />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Email :
                  </Typography>
                  <TextField source="company.user.email" emptyText="-" />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Mobile :
                  </Typography>
                  <TextField source="company.mobile" />
                </Grid>
              </SanitizedGrid>
            )}
          />
          <CustomDateField source="createdAt" emptyText="-" isDateTime />
          <StatusField source="status" />
          <FunctionField
            label="Actions"
            render={(record: any) => (
              <ActionsMenu
                render={[
                  <ListShowButton record={record} />,
                  availableOnlySuperAdminAndAdminAndFinance() && (
                    <ListEditButton record={record} />
                  ),
                ]}
              />
            )}
          />
        </Datagrid>
      </ListWrapper>
    </>
  );
};

export default PersonInChargeList;
